import { RouteConfig } from "vue-router"
import AuthLayout from "@/components/layout/Auth.vue"

export const authRoutes: RouteConfig[] = [
    {
        path: "/auth",
        component: AuthLayout,
        meta: { auth: false },
        children: [
            {
                path: "token-validation",
                name: "TokenValidation",
                component: () => import("@/views/public/TokenValidation.vue"),
                meta: { auth: false },
            },
            {
                path: "login",
                name: "Login",
                component: () => import("@/views/public/Login.vue"),
                meta: { title: "Login", auth: false },
            },
            {
                path: "register",
                name: "Register",
                component: () => import("@/views/public/Register.vue"),
                meta: { title: "Register", auth: false },
            },
            {
                path: "verify-email",
                name: "VerifyEmailAddress",
                component: () => import("@/views/public/VerifyEmail.vue"),
                meta: { title: "Verify email address", auth: false },
            },
            {
                path: "forgotten-password",
                name: "ForgottenPassword",
                component: () => import("@/views/public/ForgottenPassword.vue"),
                meta: { title: "Forgotten Password", auth: false },
            },
            {
                path: "reset-password",
                name: "ResetPassword",
                component: () => import("@/views/public/ResetPassword.vue"),
                meta: { title: "Reset Password", auth: false },
            },
            {
                path: "awaiting-email-verification",
                name: "AwaitingEmailVerification",
                component: () => import("@/views/public/AwaitingEmailVerification.vue"),
                meta: { title: "Awaiting Email Verification", auth: false },
            },
            {
                path: "privacy-policy",
                name: "PrivacyPolicy",
                component: () => import("@/views/public/PrivacyPolicy.vue"),
                meta: { title: "Privacy Policy", auth: false },
            },
            {
                path: "support",
                name: "Support",
                component: () => import("@/views/public/Support.vue"),
                meta: { title: "Support", auth: false },
            },
        ],
    },
]
